import resetState from './quick-view-state'

export default {
  reset (state) {
    Object.assign(state, resetState())
  },
  setProduct (state, data) {
    state.product = data
  },
  setGWPModal (state, data) {
    state.isGWP = data
  },
  setVariant (state, data) {
    state.selectedVariant = data
  },
  setMicroCollectionProducts (state, data) {
    state.microCollectionProducts = data
  },
  setLoading (state, isLoading) {
    state.loading = isLoading
  },
  setActiveCategory (state, payload) {
    state.activeCategory = payload
  },
  setModalTitle (state, payload) {
    state.modalTitle = payload
  },
  setCtaText (state, payload) {
    state.ctaText = payload
  },
  setItemToUpdate (state, payload) {
    state.itemToUpdate = payload
  },
  setAction (state, payload) {
    state.action = payload
  }
}
